import React, { useState } from 'react';
import { TreeSelect } from 'antd';
import 'antd/dist/antd.css';
import services from '../../services';
import GestaoRSGrid from './GestaoRSGrid';

class DropdownFinalidades extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      arrayTemas: [], // Array de temas carregados da API
      selectedValue: null, // Para armazenar o valor selecionado (único)
      expandedKeys: [], // Para controlar as chaves expandidas
    };
  }

  componentDidMount() {
    this.GetFinalidades();
  }

  // Função para buscar as finalidades da API
  GetFinalidades = async () => {
    const data = {};
    const Finalidades = await services.apiCall.requestApi(
      "/RequisicaoServicos/GetAllFinalidades",
      data,
      "get"
    );

    if (Finalidades) {
      const temas = [];
      Finalidades.forEach((item, index) => {
        const arraySubTemas = Finalidades.filter(c => c.idCatFinalidade === index + 1);

        if (arraySubTemas.length > 0) {
          const result = arraySubTemas.map(val => ({
            label: val.desfinalidade,
            value: `${val.idFinalidade}-${arraySubTemas[0].idCatFinalidade}`, // ID do subtema
          }));

          temas.push({
            label: arraySubTemas[0].descatfinalidade, // Tema (não será selecionado)
            value: arraySubTemas[0].idCatFinalidade,  // Tema não será selecionado
            children: result, // Subtemas (que serão selecionáveis)
          });
        }
      });
      this.setState({ arrayTemas: temas });
    }
  };

  // Função para lidar com a seleção de um único item
  handleSelect = (value) => {
    this.setState({ selectedValue: value });
    console.log("Selecionado:", value);
    GestaoRSGrid.GetIDFinalidade(value)
  };

  // Controla a expansão das chaves
  onExpand = (expandedKeys) => {
    this.setState({ expandedKeys });
  };

  render() {
    const { arrayTemas, selectedValue, expandedKeys } = this.state;

    return (
      <div>
        <p>Finalidades</p>
        <TreeSelect
          treeData={arrayTemas}
          value={selectedValue} // Correção: deve ser o valor selecionado
          onChange={this.handleSelect} // Correção: chamada para selecionar
          expandedKeys={expandedKeys} // Controlando a expansão das chaves
          onExpand={this.onExpand} // Função para expandir ou recolher os nós
          placeholder="Selecione uma finalidade"
          treeDefaultExpandAll={false} // Mantendo todos os itens fechados por padrão
        />
      </div>
    );
  }
}

export default DropdownFinalidades;
